import React from 'react';
import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import { useGATrackingForSSR } from '../../utils/gaTracking';

import Feeds from './components/Feeds/Feeds';
import { HomepageToastContainer } from './components/Toast/ToastNotification';

const HomepageApp = ({ appState, environment }) => {
  useGATrackingForSSR();

  const { feeds, feedPostcode, initialFeed, favoriteAdIds } = appState;

  return (
    <EnvironmentProvider value={environment}>
      <Feeds feeds={feeds} feedPostcode={feedPostcode} initialFeed={initialFeed} favoriteAdIds={favoriteAdIds} />
      <HomepageToastContainer />
    </EnvironmentProvider>
  );
};

export default HomepageApp;
